<template lang="pug">
  #my-steps-chart
    .columns
      .column
        WtTitle(card-title-large) {{ titleText }}
      .column
        DashboardChartFilters(
          v-if="!isProfile"
          :days-in-chart="daysInChart"
          @set-days-in-chart="onSetDaysInChart"
          @set-metric-type="onSetMetricType"
        )
    template(v-if="!_.isEmpty(stepData)")
      StepsChart(v-if="metricTypeSteps" :days-in-chart="daysInChart" :stepData="stepData")
      WellnessMetricsChart(v-if="metricTypeWellness" :days-in-chart="daysInChart" :metric-type="metricType")

    .empty-state(v-else)
      p Hey there,
      p A chart will show here when data is available.
</template>

<script>
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import DashboardChartFilters from "@@/Members/DashboardChartFilters";
import StepsChart from "@@/Members/StepsChart";
import WellnessMetricsChart from "@@/Members/WellnessMetricsChart";

export default {
  name: "DashboardChart",

  components: {
    DashboardChartFilters,
    StepsChart,
    WellnessMetricsChart,
    WtTitle
  },

  mixins: [dateUtilityMixin],

  props: {
    isProfile: {
      type: Boolean,
      default: false
    },

    memberUsername: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      daysInChart: 7,
      backgroundColor: null,
      metricType: "steps"
    };
  },

  computed: {
    ...mapGetters("members", ["member", "stepData", "wellnessChartData"]),

    metricTypeSteps() {
      return this.metricType.includes("steps");
    },

    metricTypeWellness() {
      return !this.metricType.includes("steps");
    },

    titleText() {
      let member = this.isProfile ? `${this.memberUsername}'s` : "My";

      return `${member} Progress Chart`;
    }
  },

  methods: {
    onSetDaysInChart(event) {
      this.daysInChart = event;
    },

    onSetMetricType(event) {
      this.metricType = event;
    }
  }
};
</script>

<style lang="sass" scoped></style>
